<template>
  <section>
    <h1 class="title has-text-centered">โปรดโอนเงินและแนบหลักฐานการชำระเงินด้านล่าง</h1>
    <payment-detail :payment="payment" :novel="novel" :subscription="subscription" hasContact></payment-detail>
    <br>
    <donate :accounts="novel.donate[payment.method]"></donate>
  </section>
</template>

<script>
import Donate from '@/views/Donate'
const PaymentDetail = () => import(/* webpackChunkName: "payment_detail" */ '@/components/PaymentDetail')

export default {
  components: {
    PaymentDetail,
    Donate
  },
  props: {
    payment: Object,
    novel: Object,
    subscription: Object
  }
}
</script>

<style lang="scss">
.image-centered {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 40%;
}
</style>
